import { List, useDataGrid } from "@refinedev/mui";
import React from "react";

import { IFisUser } from "./interfaces";
import { SearchToolbar, DataGridPanel, ListPageHeader } from "components/list";
import { fisUsersColumns } from "./components/fisUsersColumns";
import { fisUsersSearchFields } from "./components/fisUsersSearchFields";

export const FisUserList: React.FC = () => {
    const { dataGridProps, setFilters, filters, tableQueryResult } =
        useDataGrid<IFisUser>({
            initialCurrent: 1,
            initialPageSize: 20,
        });

    // refine의 rowCount는 fetch 중 잠깐 0으로 떨어져 "전체 0건"이 깜빡인다.
    // 로딩이 아닐 때의 마지막 값을 유지해 표시한다.
    const lastRowCountRef = React.useRef<number | undefined>(undefined);
    if (!dataGridProps.loading && typeof dataGridProps.rowCount === "number") {
        lastRowCountRef.current = dataGridProps.rowCount;
    }

    return (
        <List breadcrumb={<></>}>
            <ListPageHeader
                count={lastRowCountRef.current}
                description="아이러빗 내부 직원 계정 목록"
            />

            <SearchToolbar
                fields={fisUsersSearchFields}
                filters={filters}
                setFilters={setFilters}
            />

            <DataGridPanel
                {...dataGridProps}
                columns={fisUsersColumns}
                getRowShowPath={(row) => `/fisUsers/show/${row.id}`}
                isError={tableQueryResult.isError}
                errorMessage="직원 목록을 불러오지 못했습니다."
                emptyMessage="조건에 맞는 직원이 없습니다."
                pageSizeOptions={[10, 20, 30, 50, 100]}
                disableColumnFilter
                filterModel={undefined}
            />
        </List>
    );
};
